import app from 'flarum/forum/app';
export default function loadLegalDocument(slug) {
  // Slug сначала нормализуется клиентским маршрутом, а сервер повторно проверяет его по белому списку.
  return app.request({
    method: 'GET',
    url: `${app.forum.attribute('apiUrl')}/devconnect/legal/${encodeURIComponent(slug)}`
  });
}
flarum.reg.add('devconnect-legal', 'forum/service/legalApi', loadLegalDocument);